import { useParams } from "react-router-dom";
import { EntityNotFound } from "features/layouts";
import type { Project } from "features/reviewable";
import { useProject, ReviewableTemplate } from "features/reviewable";
import { useReviews } from "features/reviews";

function ProjectDetails() {
  const { projectId } = useParams() as { projectId: string };
  const { data: project, ...query } = useProject(projectId);
  const { data: reviewsResponse } = useReviews("PROJECT", projectId);
  const reviews = reviewsResponse?.data;

  const notFound = (
    <EntityNotFound type="project" linkText="Explore" linkTo="/search">
      You can find more projects on the Explore page, try searching or applying
      filters to find what you&apos;re looking for.
    </EntityNotFound>
  );

  return (
    <ReviewableTemplate
      entity={project as Project}
      {...query}
      reviews={reviews ?? []}
      notFound={notFound}
    />
  );
}

export { ProjectDetails };
